import React, { ReactElement } from 'react';

const SvgBurger = (props: React.SVGProps<SVGSVGElement>): ReactElement => (
    <svg viewBox="0 0 30 30" height="30" width="30" fill="currentColor" {...props}>
        <path d="M8 10h14v1H8zM8 20h14v1H8zM8 15h14v1H8z" fillRule="evenodd" />
    </svg>
);

export default SvgBurger;
